import { useContext, useEffect } from 'react';
import PaginationContext from 'contexts/PaginationContext';

const usePagination = ({ items, page, itemsPerPage } = { page: 1, items: [], itemsPerPage: 10 }) => {
  const {
    itemsOnPage,
    setItemsOnPage,
    setPageCount,
    pageCount,
  } = useContext(PaginationContext);

  const paginate = (array, pageSize, pageNumber) => array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);

  useEffect(() => {
    setPageCount(items.length ? Math.ceil(items.length / (itemsPerPage || 10)) : 0);
    setItemsOnPage(paginate(items, (itemsPerPage || 10), page > pageCount ? pageCount : page));
  }, [items, itemsPerPage, page, pageCount, setItemsOnPage, setPageCount]);

  return { itemsOnPage, pageCount };
};

export default usePagination;
